import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=71222d9e"
import script from "./submit.vue?vue&type=script&lang=js"
export * from "./submit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports